import { connect } from 'react-redux';
import { getDocumentById, isLoading, getCurrentResource } from 'store/selectors/resources';
import ResourcePage from 'components/ResourcePage';
import { resourcesLoadData } from 'store/actionCreators/resources';

const mapStateToProps = (state, { resourceId }) => ({
  isData: !!getDocumentById(resourceId)(state),
  loading: isLoading(state),
  currentResource: getCurrentResource(state),
});

const mapDispatchToProps = {
  resourcesLoadData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResourcePage);
